import { useEffect, useState, useRef } from "react";
export function useIdleTimer(timeout = 30000, enabled = true) {
  // timeout in ms, e.g. 30 sec
  const [isIdle, setIsIdle] = useState(false);
  const timerRef = useRef(null);
  const resetTimer = () => {
    if (isIdle) setIsIdle(false);
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      setIsIdle(true);
    }, timeout);
  };
  useEffect(() => {
    if (!enabled) return;
    const events = [
      "mousemove",
      "mousedown",
      "keypress",
      "scroll",
      "touchstart",
    ];
    for (const event of events) {
      window.addEventListener(event, resetTimer);
    }

    resetTimer(); // Start the timer on mount

    return () => {
      for (const event of events) {
        window.removeEventListener(event, resetTimer);
      }
      clearTimeout(timerRef.current);
    };
  }, []);
  return isIdle;
}
